import _ from 'lodash';

const TermsServiceFactory = (NewBackendService, Environment, $q, $timeout, FoundationApi, ModalFactory, NewMerchantProfileService, StorageService) => {
  'ngInject';

  const parseTermsResponse = (termsResponse) => {
    const terms = _.sortBy(_.map(termsResponse, (term) => {
      term.url = `${Environment.endPoints.baseUrl}/api/usr/v2/documents/terms/${term.termId}`; // eslint-disable-line
      return term;
    }), (term) => term.termId);
    /*return {
      documents: _.filter(terms, (term) => term.accepted === 1 && term.radiobutton === 0),
      terms: _.filter(terms, (term) => term.accepted === 1 && term.radiobutton === 1)
    };*/
    return terms
  };

  const getTerms = (terms) => $q((resolve, reject) => {
      var filterOptions = {};
      filterOptions.level = terms ? terms.level : undefined
      filterOptions.type = terms ? terms.type : undefined
      NewBackendService.invokeWebApiGet('/api/usr/v2/documents/terms', filterOptions, true).then((termsResponse) => {
        resolve(parseTermsResponse(termsResponse.data._embedded.terms));
      }, reject);
  });

  const service = {
    getVasMerchantTerms: () => {
      var merchantContext = JSON.parse(StorageService.getLocalStorage('userContext'));
      var level = merchantContext.defaultWallet ? merchantContext.defaultWallet.level : merchantContext.context ? merchantContext.context.walletLevel : "";
      return getTerms({ level: 1, type: level})},

      checkAcceptedMerchantTerms: () => {
        service.getTerms(false).then((terms) => {
            var ConvMerchantTerms = _.filter(terms, (term) => (term.termId === 201 || term.termId === 202));
            if(ConvMerchantTerms.length == 0){
              getTerms({ level: 4}).then((terms) => {
                ConvMerchantTerms = _.filter(terms, (term) => (term.id === 201 || term.id === 202));
                service.openConvMerchantModal(ConvMerchantTerms);
              })
            }else{  
              ConvMerchantTerms = _.filter(terms, (term) => (term.termId === 201 || term.termId === 202) && term.accepted == false);
              if (ConvMerchantTerms.length) {
                service.openConvMerchantModal(ConvMerchantTerms)
              }
            }
        });
      },

      openConvMerchantModal: (ConvMerchantTerms) => {
        const closeModal = modal => {
          modal.deactivate();
          $timeout(() => {
            modal.destroy();
          }, 1000);
        };
        const isSA = StorageService.getLocalStorage('superAdmin');
        FoundationApi.closeActiveElements();

        const modal = new ModalFactory({
          class: 'large',
          overlay: true,
          overlayClose: false,
          template: '<merchant-terms-modal termini="terms" on-close="close()"></merchant-terms-modal>',
          contentScope: {
            close: () => closeModal(modal),
            terms: ConvMerchantTerms
          }
        });
        if (isSA === undefined) {
          modal.activate();
        }
      },
    
    /*checkAcceptedMerchantTerms: () => {
      NewMerchantProfileService.getMerchantProfile(undefined, true).then((context) => {
        if (context.TerminiNonAccettati !== undefined) {
          const ConvMerchantTerms = _.filter(context.TerminiNonAccettati, (term) => term.idtermini === 200 || term.idtermini === 201 || term.idtermini === 202);
          if (ConvMerchantTerms.length) {
            _.forEach(ConvMerchantTerms, term => { term.accettato = 0 }); // eslint-disable-line
            const closeModal = modal => {
              modal.deactivate();
              $timeout(() => {
                modal.destroy();
              }, 1000);
            };
            const isSA = StorageService.getLocalStorage('superAdmin');
            FoundationApi.closeActiveElements();

            const modal = new ModalFactory({
              class: 'large',
              overlay: true,
              overlayClose: false,
              template: '<merchant-terms-modal termini="terms" on-close="close()"></merchant-terms-modal>',
              contentScope: {
                close: () => closeModal(modal),
                terms: ConvMerchantTerms
              }
            });
            if (isSA === undefined) {
              modal.activate();
            }
          }
        }
      });
    },*/

    getTerms: (filter) => $q((resolve, reject) => {
      var business = "me"
      if(StorageService.getLocalStorage('superAdmin')){
        business = JSON.parse(StorageService.getLocalStorage('userContext')).business.id
      }
      NewBackendService.invokeWebApiGet('/api/usr/v2/users/'+business+'/terms?page=0&size=1000', true).then((termsResponse) => {
        if(filter){
        resolve(parseTermsResponse(_.filter(termsResponse.data._embedded['accepted-terms'], (term) => (term.radio == true && term.mandatory == false && term.type == 0))));
        }else{
          resolve(parseTermsResponse((termsResponse.data._embedded['accepted-terms'])));
        }
      }, reject);
    }),

    modifyTerms: (acceptedTermIds, rejectedTermIds) => $q((resolve, reject) => {
      var req = {
        "acceptedTermIds" : acceptedTermIds,
        "rejectedTermIds" : rejectedTermIds,
      }
      NewBackendService.invokeWebApiPost('/api/usr/v2/users/me/terms', req, true).then((termsResponse) => {
        resolve(termsResponse);
      }, reject);
    }),

    getPrivacyTerms: () => $q((resolve, reject) => {
      // TODO: remove useless code
      const request = {
        data: {
          request: {
            getTerminiAccettatiRifiutatiRequest: {}
          }
        },
        userContext: {}
      };
      const radio = 1;

      request.data.request.getTerminiAccettatiRifiutatiRequest.filter = {
        livello: 0
      };

      NewBackendService.invokeWebApiPost('registrazione/getTerminiAccettatiRifiutati', request).then((result) => {
        if (result && 'data' in result) {
          const terms = result.data.response.getTerminiAccettatiRifiutatiResponse.terminiAccettatiRifiutati
            .filter((o) => o.radiobutton === radio && !(o.mandatory && o.accettato));
          resolve(terms);
        } else {
          reject('Wrong response from the service');
        }
      }, (reason) => {
        reject(reason);
      });
    }),
    setTerms: (terms) => NewBackendService.invokeWebApiPost('registrazione/setTerminiAccettatiRifiutati', {
      userContext: {},
      data: {
        request: {
          setTerminiAccettatiRifiutatiRequest: {
            terminiAccettatiRifiutati: terms
          }
        }
      }
    }, true)
  };

  return service;
};

export default TermsServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/terms.factory.js
 **/